import { UserProfile } from '@app/types/app.types';
import {
  Filter,
  SELECTED_FILTER_VALUES,
  SELECTED_VOID_FILTER_VALUES,
  VoidFilterPayload,
} from '@app/types/filter.types';
import { createAction, props } from '@ngrx/store';

export const setFilters = createAction('[Filters] setFilters', props<{ filters: Filter[] | null }>());
export const setVoidFilters = createAction('[Filters] setVoidFilters', props<{ filters: Filter[] | null }>());

export const setVoidAppliedFilters = createAction(
  '[Filters] setVoidAppliedFilters',
  props<{ filters: SELECTED_VOID_FILTER_VALUES[] | null }>(),
);
export const setVoidFilterPayload = createAction(
  '[VoidFilterPayload] voidFilterPayload',
  props<{ voidFilterPayload: VoidFilterPayload }>(),
);
export const setHardFilters = createAction(
  '[Preference] setHardFilters',
  props<{ hardFilters: SELECTED_FILTER_VALUES[] | null }>(),
);

export const setAzureAccessToken = createAction(
  '[App] setAzureAccessToken',
  props<{ accessToken: string | null; idToken: string | null }>(),
);
export const setProfile = createAction('[App] setProfile', props<{ profile: UserProfile }>());

export const resetVoidFilterPayload = createAction('[Void Filter] Reset Filter Payload');

export const resetVoidAppliedFilters = createAction('[Void Applied Filters] Reset Void Applied Filters');

export const selectSKU = createAction('[Void Report] Select SKU for export', props<{ sku: string }>());

export const deselectSKU = createAction('[Void Report] Deselect SKU from export', props<{ sku: string }>());

export const clearSelectedSKU = createAction('[Void Report] Clear selected SKUs');

export const prefFilters = createAction('[PrefFilters] setPrefFilters', props<{ prefFilters: Filter[] | null }>());

export const setScreenAccess = createAction(
  '[Screen Access] Stores screen access',
  props<{ screenAccessState: string[] }>(),
);

export const setRecsBatchDate = createAction('[Filters] setRecsBatchDate', props<{ recsBatchDate: string }>());

export const setVoidBatchDate = createAction('[Filters] setVoidBatchDate', props<{ voidBatchDate: string }>());
